<script setup lang="ts">
  import type { FillLogsValue } from '../model/fill-logs-text';

  defineProps<{ value: FillLogsValue }>();
</script>

<template>
  <span
    class="whitespace-pre-wrap [overflow-wrap:anywhere]"
    :class="{ 'italic text-gray-03': value.empty }"
  >{{ value.text }}</span>
</template>
